var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-page__row"},[_c('h3',[_vm._v(_vm._s(_vm.$t('createEnvelope.documentSelectionConfirmation.yourSelectedDocuments')))]),_c('VDocumentListCollapsed',{attrs:{"selected":_vm.$store.state.envelopes.creating.envelope.documents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }